export const awsExports = {
    "REGION" : "us-east-2",
    "USER_POOL_ID": "us-east-2_I2O2UY6fw",
    "USER_POOL_APP_CLIENT_ID": "hsqhthquipmaftbuikj7cr1c7",
    "IDENTITY_POOL_ID": "us-east-2:fd73e217-5635-41dd-8586-87faf5d6a6fb",
    "BUCKET_NAME": "skroot-data",
    "ACCESS_PREFIX": "experiments/" // the path to the group's folders
}
